<template>
  <v-card-text v-if="canEdit">
    <form @submit.prevent="submit()">
      <template v-for="input in inputs">
        <component
          :key="input.key"
          :is="input.component"
          :config="input"
          v-model="$data[input.key]">
        </component>
      </template>
      <v-card-row actions>
        <v-btn
          type="submit"
          primary light ripple
          :loading="loading">
          {{ $t('accounts.informations.save') }}
        </v-btn>
      </v-card-row>
    </form>
  </v-card-text>
</template>

<script>
  import Expert from '@/api/currentExpert'
  import { TextInput } from '@/components/inputs'
  import expert from '@/mixins/expert'
  import { mapGetters } from 'vuex'
  export default {
    mixins: [expert],
    data () {
      return {
        error: {},
        email: this.expert.email,
        password: ''
      }
    },
    computed: {
      ...mapGetters({
        curentUser: 'skiliko/session/currentUser'
      }),
      canEdit () {
        if (Expert.isAdmin(this.curentUser)) { return true }
        return this.curentUser.id === this.expert.id
      },
      inputs () {
        return [
          { key: 'email', type: 'email', component: TextInput },
          { key: 'password', component: TextInput, type: 'password' }
        ]
          .map(input => ({
            ...input,
            required: true,
            label: this.$t(`accounts.informations.labels.${input.key}`),
            errors: (this.error[input.key] || []).map(e => () => e)
          }))
      }
    },
    methods: {
      submit () {
        this.save({
          id: this.expert.id,
          data: { ...this.$data }
        })
          .catch(({ response }) => (this.error = (response || {}).data || {}))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/expert/Connection.vue